import type { ReactNode } from 'react'

import { t } from '@/lib/i18n'
import styles from './ErrorState.module.css'

interface ErrorStateProps {
  /** Short headline */
  title?: string
  /** The error object — message extracted if it's an ApiError */
  error: unknown
  /** Called when the user clicks "다시 시도" */
  onRetry?: () => void
  /** Optional extra context, e.g. which query failed */
  hint?: ReactNode
}

export function ErrorState({
  title = t('Failed to load data'),
  error,
  onRetry,
  hint,
}: ErrorStateProps) {
  const message = error instanceof Error ? error.message : String(error)

  return (
    <div className={styles.wrap} role="alert">
      <div className={styles.icon} aria-hidden="true">
        ⚠
      </div>
      <div className={styles.body}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.message}>{message}</p>
        {hint && <p className={styles.hint}>{hint}</p>}
      </div>
      {onRetry && (
        <button type="button" className={styles.retry} onClick={onRetry}>
          {t('Retry')}
        </button>
      )}
    </div>
  )
}
